import React from 'react'
import AssetManagement from '../PureContainer/AssetManagement'

const RenderAssetManagement = () => {
  return (
   <AssetManagement/>
  )
}

export default RenderAssetManagement